<template>
  <b-row no-gutters>
    <b-col cols="0" md="2"></b-col>

    <b-col class="p-4">
      <div class="rounded bg-lightblack p-3">
        <div class="comments-part">
          <img src="@/assets/jeanluc.png" class="float-left user-photo rounded-circle mr-2" />
          <div>
            <strong class="text-white text-capitalize">Jean-Luc NOÉ</strong>
            <div class="published-on mt-n1 created-at">Aujourd'hui</div>
          </div>

          <div class="border-top-primary-dark mt-4 mb-2"></div>

          <div v-if="!isAuthenticated">
            <p class="text-white">{{ firstName }},</p>

            <p class="text-white mt-2">Toutes mes félicitations pour être arrivé à ce niveau de votre lecture Numérologique !</p>

            <p class="text-white mt-2">Pour récapituler :</p>
            <p class="text-white">
              Votre Vibration Intime est le <strong>{{ lifepath }}</strong
              >.
            </p>

            <p class="text-white mt-2">Maintenant, l'étape suivante est de calculer votre Nombre de la Destinée.</p>

            <p class="text-white mt-2">
              Le Nombre de la Destinée se calcule avec les lettres de votre nom complet. Je vais commencer par faire correspondre
              chaque lettre à son équivalent en Alphabet Pythagoricien, et avec ces références, je vais calculer votre Nombre de
              la Destinée.
            </p>

            <p class="text-white mt-2">
              Pour des raisons de sécurité évidentes, son calcul est donc réservé aux membres de J.L. AI®.
            </p>

            <p class="text-white">
              L'inscription est totalement gratuite ! Cela nous permet simplifier de sécuriser vos informations par mot de passe.
            </p>

            <div class="border-top-primary-dark mt-4 mb-2"></div>

            <login-form v-if="action === 'login'" @register="action = 'register'" />
            <register-form v-else @login="action = 'login'" :p-first-name="user.firstName" />
          </div>

          <full-name v-else :gender="user.gender" v-on="$listeners" />
        </div>
      </div>
    </b-col>

    <b-col cols="0" md="2"></b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";
import { BRow, BCol } from "bootstrap-vue";

import RegisterForm from "@/components/Auth/Register";
import LoginForm from "@/components/Auth/Login";

import FullName from "./FullName.vue";

export default {
  name: "FormRegister",
  components: { BRow, BCol, LoginForm, RegisterForm, FullName },
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  data: () => ({
    action: "register",
  }),
};
</script>

<style scoped>
.user-photo {
  width: 40px;
  height: 40px;
}

@media screen and (max-width: 576px) {
  .user-photo {
    width: 20px;
    height: 20px;
  }
}
</style>
